module.exports = __webpack_public_path__ + "static/img/WechatIMG37New.296def02.jpg";